// extracted by mini-css-extract-plugin
export default {"cont":"EmbeddedCode_cont__6a8mF","buttonCont":"EmbeddedCode_buttonCont__rtfP-"};